<ng-template [ngIf]="picker.content" [ngIfElse]="default"
             [ngTemplateOutlet]="picker.content">
</ng-template>
<ng-template #default>
  <color-chrome [color]="picker.selected"
                (onChangeComplete)="picker.select(getColorString($event))">
  </color-chrome>
</ng-template>
